import React, { useState, useEffect } from 'react';
import Padampurafront from '../images//Padampurafront.jpg';
import room1 from '../images/room1.jpg';
import room2 from '../images/room2.jpg';
import room3 from '../images/room3.jpg';
import room4 from '../images/room4.jpg';
import CheckIn from '../images/checkin.png';
import hygiene from '../images/hygiene.png';
import wifi from '../images/wifi.png';
import housekeep from '../images/housekeep.png';
import { FaLocationDot } from 'react-icons/fa6';
import Carousel from 'react-bootstrap/Carousel';
import { IoMan } from "react-icons/io5";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { useParams } from 'react-router-dom';
import { MdCall } from 'react-icons/md';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { useForm } from 'react-hook-form';
import axios from 'axios';

const currentDate = new Date();
const formattedDate = currentDate.toISOString().split('T')[0];

export default function DharmshalaDetail() {

  const { id } = useParams();
  const { register, watch, setValue, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      DeleuxRoom: 0,
      Executive: 0,
      Family: 1,
      Suite: 0
    }
  })
  const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 } } = useForm({})
  let bookingDetails = watch()
  // console.log(bookingDetails)

  const [validateDate, setValidateDate] = useState()
  const mndrGallery = [
    {
      mndrImg: room1
    },
    {
      mndrImg: room2
    },
    {
      mndrImg: room3
    },
    {
      mndrImg: room4
    },
    {
      mndrImg: room1
    },
    {
      mndrImg: room2
    },
  ]
  const handleRoomBooking = (data) => {
    console.log(data)

  }

  const [shalaData, setshalaData] = useState({});
  const [fromDate, setfromDate] = useState(formattedDate);
  const [toDate, settoDate] = useState('');
  const [noOfRoom, setnoOfRoom] = useState(0);
  const [roomTypes, setRoomTypes] = useState([])

  const [imgSlider, setimgSlider] = useState([]);

  const imgArry = [
    {
      cap1: 'First slide label',
      cap2: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
      img: room1,
    },
    {
      cap1: 'First slide label',
      cap2: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
      img: room2,
    },
    {
      cap1: 'First slide label',
      cap2: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
      img: room3,
    },
  ]


  const shalaDetail = async () => {
    try {
      let response = await axios.get(`https://api.padampura.com/Dharmshalas_byid?id=${id}`)
      // console.log(response.data.data)
      setshalaData(response.data.data)
    } catch (error) {
      console.log('Error while geting Dharmshalas_byid', error)
    }
  }


  const fetchRoomList = async () => {
    let roomType = []
    try {
      let response = await axios.get("https://api.padampura.com/All_RoomTypes")
      // console.log(response.data.data)
      if (response.data.status === true) {
        response?.data?.data?.forEach(element => {
          roomType.push(
            {
              [element.RMT_type]: {
                RMT_type: `${element?.RMT_type}`,
                id: `${element.RMT_id}`
              }
            }
          )
        })
      }

      const unique = roomType.reduce((acc, obj) => {
        const value = Object.values(obj)[0];
        const key = value.RMT_type.toLowerCase(); // normalize

        if (!acc.map[key]) {
          acc.map[key] = true;
          acc.result.push(obj);
        }

        return acc;
      }, { map: {}, result: [] }).result;

      // console.log(unique);


      setRoomTypes(unique)
    } catch (error) {
      console.error('Error while geting Room List', error)
    }
  }



  const handleRoomAvailability = async (data) => {
    console.log(data)
    try {
      let response = await axios.post('https://api.padampura.com/BookingAvailability', data)
      console.log(response.data)
      setnoOfRoom(response?.data?.data || 0)
    } catch (error) {
      console.error('error while geting Room Availability', error)
    }
  }



  useEffect(() => {
    const nextDate = new Date(fromDate);
    nextDate.setDate(nextDate.getDate() + 1);
    settoDate(nextDate.toISOString().split('T')[0]);
  }, [fromDate]);

  const reservationInsert = () => {
    if (!fromDate || !toDate) {
      alert('Please select From or Till date')
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      // "reserv_id": "6",
      // "reserv_no": "1",
      "reserv_check_in": fromDate,
      "reserv_check_out": toDate,
      "reserv_book_date": formattedDate,
      // "reserv_guest_name": reserv_guest_name,
      // "reserv_mob": reserv_mob,
      // "reserv_mail": reserv_mail,
      "reserv_is_cancel": false,
      "reserv_is_aprove": false,
      "reserv_is_sync": false,
      // "details": formData
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://api.padampura.com/Reservation_Insert", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          // console.log(result)
          alert("Booking Requested Send 👍")
        } else {
          alert("Try Again 😉")
        }
      })
      .catch((error) => console.error(error));
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  useEffect(() => {
    setimgSlider(imgArry);
    shalaDetail();
    fetchRoomList();
    scrollToTop();
    setfromDate(getCurrentDate());
  }, [imgArry])

  useEffect(() => {
    let today = new Date()
    let year = today.getFullYear()
    let month = (today.getMonth() + 1).toString().padStart(2, '0')
    let day = today.getDate().toString().padStart(2, '0')

    //min
    let obj = {}
    obj.startDate = `${year}-${month}-${day}`
    //max
    let DateAfter3Month = new Date(today.setMonth(today.getMonth() + 3))
    let afterYear = DateAfter3Month.getFullYear()
    let afterMonth = (DateAfter3Month.getMonth() + 1).toString().padStart(2, '0')
    let afterDay = DateAfter3Month.getDate().toString().padStart(2, '0')
    obj.endDate = `${afterYear}-${afterMonth}-${afterDay}`
    setValidateDate({ ...obj })
  }, [])
  // roomTypes.forEach((r)=>{
  //   console.log(r[Object.keys(r)[0]].RMT_type)
  // })
  // console.log(formattedDate)
  console.log(errors1)

  return (
    <div>
      <div className='mt-3'>
        <div class="main-div">
          <img class="background-div" src={Padampurafront} alt="Sea" style={{ objectFit: 'cover' }} />
          <div className='container'>
            <div className='row p-5'>
              <div className='col-lg-12 col-md-8 col-sm-12 m-auto py-5'>
                <div className='card bg-transparent border-0 text-center my-5'>
                  <div class="div-content py-4">
                    <p className='' style={{ fontFamily: 'Poppins', fontSize: "3em", color: '#fff', fontWeight: 400 }} >{shalaData?.dhrm_name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container mt-5'>
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12'>
            <Carousel>
              {
                imgSlider.map((item, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <img src={item.img} alt="" style={{ width: '100%', objectFit: "cover" }} />
                      <Carousel.Caption>
                      </Carousel.Caption>
                    </Carousel.Item>
                  )
                })
              }
            </Carousel>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div style={{ fontFamily: 'Poppins', fontSize: "1.5em", color: '#000', fontWeight: 500, }} >{shalaData?.dhrm_name}</div>
            <div className='d-flex pt-2 align-items-center'>
              <FaLocationDot className='me-2' style={{ color: 'orangered', fontSize: '14px' }} />
              <div className="" style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>{shalaData?.dhrm_location}</div>
            </div>
            <div className="py-2" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>{shalaData?.dhrm_desc}</div>
            <div className='row py-2 d-flex align-items-center'>
              <div className='col-6'>
                <div className='d-flex'>
                  <MdCall className='me-2' style={{ color: 'orangered', fontSize: '16px', }} />
                  <div style={{ fontFamily: "Poppins", fontSize: '15px', fontWeight: 500, color: "#1f5156", letterSpacing: 1.5 }}>+91 {shalaData?.dhrm_mob}</div>
                </div>
                <div className='d-flex pt-2'>
                  <MdCall className='me-2' style={{ color: 'orangered', fontSize: '16px', }} />
                  <div style={{ fontFamily: "Poppins", fontSize: '15px', fontWeight: 500, color: "#1f5156", letterSpacing: 1.5 }}>{shalaData?.dhrm_phone}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container mt-4'>
        <div className='card p-2 rounded-0'>
          <div className='row'>
            <div className='col-12'>
              <p className='' style={{ fontFamily: 'Poppins', fontSize: "1.5em", color: '#1f5156', fontWeight: 500 }}>Check Room Availability</p>
              <div className='card rounded-1 p-3'>

                {/* Check Room Availability */}
                <form onSubmit={handleSubmit1(data => handleRoomAvailability(data))}>
                  <div className='row d-flex justify-content-between lh-lg align-items-center'>
                    <div className='col-lg-3 col-md-6 col-sm-12'>
                      <label className='form-label d-flex align-items-center' style={{ fontSize: '13px' }}>
                        <span className='fw-bold text-muted'>Select Room type </span>
                        {errors1?.RoomTypeID && <span className='text-danger'> {errors1?.RoomTypeID.message}</span>}
                      </label>
                      <select
                        className='form-control'
                        {...register1('RoomTypeID',
                          { required: { value: true, message: 'Select Room' } })
                        }
                      >
                        <option value="" desabled>Select A Room</option>
                        {roomTypes.map(r => {
                          return <option value={r[Object.keys(r)[0]].id}>{r[Object.keys(r)[0]].RMT_type}</option>
                        })}
                      </select>
                    </div>

                    <div className='col-lg-3 col-md-6 col-sm-12'>
                      <lable className="form-label d-flex align-items-center" style={{ fontSize: '13px' }}>
                        <span className='fw-bold text-muted'>From </span>
                        {errors1?.CheckinDate && <span className='text-danger' style={{ fontSize: '13px' }}> {errors1?.CheckinDate.message}</span>}
                      </lable>
                      <input
                        type='date'
                        className='form-control'
                        {...register1('CheckinDate', { required: { value: true, message: "CheckinDate is required!!" } })}
                      />
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12'>
                      <lable className="form-label d-flex align-items-center" style={{ fontSize: '13px' }}>
                        <span className='fw-bold text-muted'>To</span>
                        {errors1?.CheckoutDate && <span className='text-danger'>{errors1?.CheckoutDate.message}</span>}
                      </lable>
                      <input type='date' className='form-control' {...register1('CheckoutDate', { required: { value: true, message: 'CheckOut Date is Required!!' } })} />
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12'>
                      <lable className="form-label" style={{ fontSize: '13px' }}>
                      </lable>
                      <button type="submit" className='btn-hover color-3 rounded-0 px-0 py-0 mt-3' style={{ width: '100%' }}>Check Rooms</button>
                    </div>
                  </div>
                </form>
              </div>
              <p className='mt-2 text-center' style={{ fontFamily: 'Poppins', fontSize: "1.5em", color: '#1f5156', fontWeight: 500 }}>Available Rooms : {noOfRoom}</p>
            </div>

            {/* Booking insert */}
            <div className='row justify-content-center align-items-sm-center align-items-md-start'>

              <div className='col-md-8 col-12'>
                <form
                  onSubmit={handleSubmit((data) => handleRoomBooking(data))}
                  className="container shadow rounded-3 border"
                >
                  <div className="card shadow-sm border-0 p-4">
                    <h5 className="mb-4 fw-semibold text-primary">Room Booking</h5>

                    <>
                      {/* Rooms */}
                      <h6 className=" mb-2 fw-semibold text-secondary" style={{ fontSize: '14px' }}>
                        Room Preferences
                      </h6>

                      <div className="row g-3 mb-3" style={{ fontSize: '14px' }}>
                        <div className="col-6 col-md-3">
                          <label className="form-label ">Deluxe</label>
                          <input type="number" min="0" className="form-control" {...register("DeleuxRoom")} />
                        </div>

                        <div className="col-6 col-md-3">
                          <label className="form-label ">Executive</label>
                          <input type="number" min="0" className="form-control" {...register("Executive")} />
                        </div>

                        <div className="col-6 col-md-3">
                          <label className="form-label ">Family</label>
                          <input type="number" min="0" className="form-control" {...register("Family")} />
                        </div>

                        <div className="col-6 col-md-3">
                          <label className="form-label ">Suite</label>
                          <input type="number" min="0" className="form-control" {...register("Suite")} />
                        </div>
                      </div>
                    </>


                    {/* Guests Count */}
                    <h6 className="mb-2 fw-semibold text-secondary" style={{ fontSize: '14px' }}>
                      Guests
                    </h6>

                    <div className="row g-3">
                      {/* Adults */}
                      <div className="col-12 col-md-6">
                        <div className="d-flex justify-content-between align-items-center border rounded p-3" style={{ fontSize: '14px' }}>
                          <div>
                            <div className="fw-semibold">Adults</div>
                            <small className="">Age 18+</small>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => setValue("adults", Math.max(1, watch("adults") - 1))}
                            >
                              −
                            </button>

                            <span className="fw-semibold px-2">
                              {watch("adults") || 1}
                            </span>

                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => setValue("adults", (watch("adults") || 1) + 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>

                        {/* hidden input for form submit */}
                        <input
                          type="hidden"
                          {...register("adults", { value: 1, required: true })}
                        />
                      </div>

                      {/* Children */}
                      <div className="col-12 col-md-6">
                        <div className="d-flex justify-content-between align-items-center border rounded p-3" style={{ fontSize: '14px' }}>
                          <div>
                            <div className="fw-semibold">Children</div>
                            <small className="">Age 1–17</small>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => setValue("children", Math.max(0, watch("children") - 1))}
                            >
                              −
                            </button>

                            <span className="fw-semibold px-2">
                              {watch("children") || 0}
                            </span>

                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => setValue("children", (watch("children") || 0) + 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>

                        {/* hidden input for form submit */}
                        <input
                          type="hidden"
                          {...register("children", { value: 0 })}
                        />
                      </div>
                    </div>

                    {/* Dates */}
                    <div className="row g-3 mt-1">
                      <div className="col-12 col-md-6">
                        <label className="form-label " style={{ fontSize: '14px' }}>Check In</label>
                        <input
                          min={validateDate?.startDate}
                          type="date"
                          className="form-control"
                          {...register("checkin", {
                            required: { value: true, message: "Check-in date is required" },
                          })}
                          style={{ fontSize: '14px' }}
                        />
                        {errors?.checkin && (
                          <small className="text-danger">{errors.checkin.message}</small>
                        )}
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label " style={{ fontSize: '14px' }}>Check Out</label>
                        <input
                          min={validateDate?.startDate}
                          max={validateDate?.endDate}
                          type="date"
                          className="form-control"
                          {...register("checkout", {
                            required: { value: true, message: "Check-out date is required" },
                          })}
                          style={{ fontSize: '14px' }}
                        />
                        {errors?.checkout && (
                          <small className="text-danger">{errors.checkout.message}</small>
                        )}
                      </div>
                    </div>



                    {/* User Info */}
                    <div className="row g-3 mt-1">
                      <div className="col-12 col-md-6">
                        <label className="form-label " style={{ fontSize: '14px' }}>Name</label>
                        <input
                          type="text"
                          placeholder="Enter your name"
                          className="form-control"
                          {...register("userName", {
                            required: { value: true, message: "Name is required" },
                          })}
                        />
                        {errors?.userName && (
                          <small className="text-danger">{errors.userName.message}</small>
                        )}
                      </div>

                      <div className="col-12 col-md-6">
                        <label className="form-label " style={{ fontSize: '14px' }}>Phone Number</label>
                        <input
                          type="text"
                          placeholder="+91"
                          className="form-control"
                          {...register("phoneNumber", {
                            required: { value: true, message: "Phone number is required" },
                            minLength: { value: 10, message: "Invalid number" },
                          })}
                        />
                        {errors?.phoneNumber && (
                          <small className="text-danger">{errors.phoneNumber.message}</small>
                        )}
                      </div>
                    </div>

                    {/* Address */}
                    <div className="mt-3">
                      <label className="form-label " style={{ fontSize: '14px' }}>Address</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Enter your address"
                        {...register("address", {
                          required: { value: true, message: "Address is required" },
                        })}
                      />
                      {errors?.address && (
                        <small className="text-danger">{errors.address.message}</small>
                      )}
                    </div>



                    {/* Submit */}
                    <div className="d-flex gap-5 mt-4">
                      {/* <button type="submit" className="btn btn-primary btn-sm">
                        Search Rooms
                      </button> */}
                      <button type="reset" className="btn btn-secondary btn-sm">
                        reset

                      </button>
                    </div>
                  </div>
                </form>


              </div>

              <div className='col-lg-4 col-md-6 col-sm-12'>
                <div className='card rounded-1 border-1 p-2'>
                  <div className='d-flex justify-content-start'>
                    <div style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>Booking Detail</div>
                  </div>
                  <div className="shadow-sm p-3">

                    {/* Room Types */}
                    <div className="row text-center g-2 mb-2">
                      <div className="col-6 col-md-3">
                        <small className="fw-semibold">Deluxe</small>
                        <div>{bookingDetails?.DeleuxRoom}</div>
                      </div>

                      <div className="col-6 col-md-3">
                        <small className="fw-semibold">Executiv.</small>
                        <div>{bookingDetails?.Executive}</div>
                      </div>

                      <div className="col-6 col-md-3">
                        <small className="fw-semibold">Family</small>
                        <div>{bookingDetails?.Family}</div>
                      </div>

                      <div className="col-6 col-md-3">
                        <small className="fw-semibold">Suite</small>
                        <div>{bookingDetails?.Suite}</div>
                      </div>
                    </div>

                    <hr className="my-2" />

                    {/* Guests */}
                    <div className="row mb-2">
                      <div className="col-6">
                        <small className="text-muted">Adults</small>
                        <div>{bookingDetails?.adults}</div>
                      </div>
                      <div className="col-6">
                        <small className="text-muted">Children</small>
                        <div>{bookingDetails?.children}</div>
                      </div>
                    </div>

                    {/* Dates */}
                    <div className="row mb-2">
                      <div className="col-6">
                        <small className="text-muted">Check-in</small>
                        <div>{bookingDetails?.checkin}</div>
                      </div>
                      <div className="col-6">
                        <small className="text-muted">Check-out</small>
                        <div>{bookingDetails?.checkout}</div>
                      </div>
                    </div>

                    <hr className="my-2" />

                    {/* User Info */}
                    <div>
                      <p className="mb-1">
                        <strong>Name:</strong> {bookingDetails?.userName}
                      </p>
                      <p className="mb-1">
                        <strong>Phone:</strong> {bookingDetails?.phoneNumber}
                      </p>
                      <p className="mb-0">
                        <strong>Address:</strong> {bookingDetails?.address}
                      </p>
                    </div>

                  </div>


                  {(bookingDetails.userName && bookingDetails.phoneNumber && bookingDetails.address) && (bookingDetails?.checkin && bookingDetails.checkout) && <button data-bs-toggle="modal" data-bs-target="#exampleModal" className='btn-hover color-3 rounded-0 mt-3' type="submit" style={{ width: '100%' }} onClick={reservationInsert}>Book Now</button>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className='container mt-5'>
        <p className='text-center mb-5' style={{ fontFamily: 'Poppins', fontSize: "1.5em", color: '#1f5156', fontWeight: 500 }}>Mandir Gallery</p>
        <div className='row'>
          {
            mndrGallery.map((item) => {
              return (
                <div className='col-lg-2 col-md-6 col-sm-12'>
                  <div className="card rounded-0 border-0" style={{ width: '100%', }}>
                    <img src={item.mndrImg} className="card-img-top mandir-imgs rounded-0" alt="..." style={{ width: '100%', height: 100, objectFit: "cover" }} />
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
      <div className='container my-5'>
        <p className='' style={{ fontFamily: 'Poppins', fontSize: "1.5em", color: '#1f5156', fontWeight: 500 }}>Facilities</p>
        <div className='row'>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>1. Free parking</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>2. Free Wi-Fi in all room</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>3. Food & dining</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>4. Daily housekeeping</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>5. Room service</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>6. Restaurant</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>7. Swimming pool</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>8. Garden</div>
          <div className="py-1" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#1f5156', fontWeight: 500 }}>9. Security & CCTV protection</div>
          <div className="py-4" style={{ fontFamily: 'Poppins', fontSize: "12px", color: '#1f5156', fontWeight: 500 }}>Get your trip off to a great start with a stay at this property, which offers free Wi-Fi in all rooms. Conveniently situated in the Belfast Waterfront Area part of Belfast, this property puts you close to attractions and interesting dining options. Don't leave before paying a visit to the famous Crumlin Road Gaol. This 3-star property features restaurant to make your stay more indulgent and memorable.</div>
        </div>
        <div className='row'>
          <div className='card rounded-0 p-4'>
            <div className='row'>
              <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                <img src={CheckIn} alt="" style={{ width: '12%' }} />
                <div className="pt-2" style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>Check-in [24-hour]</div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                <img src={hygiene} alt="" style={{ width: '12%' }} />
                <div className="pt-2" style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>Hygiene Plus</div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                <img src={wifi} alt="" style={{ width: '12%' }} />
                <div className="pt-2" style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>Free Wi-Fi in all rooms!</div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 text-center'>
                <img src={housekeep} alt="" style={{ width: '12%' }} />
                <div className="pt-2" style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#1f5156', fontWeight: 500 }}>Daily housekeeping</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Modal --> */}
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 600 }}>Booking detail</p>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div className='row'>
                <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>ROOM</p>
                <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#000', fontWeight: 500 }}>Deluxe Room</p>
                <div className='d-flex justify-content-between align-items-center mt-2' >
                  <div className='' style={{ fontFamily: 'Poppins', fontSize: "15px", color: '#AEB6BF ', fontWeight: 600 }}><IoMan style={{ fontSize: 15, color: '#1f5156' }} />0 </div>
                  <div className='' style={{ fontFamily: 'Poppins', fontSize: "14px", color: '#3498DB', fontWeight: 400 }}>Show Description</div>
                </div>
                <div className='row mt-2'>
                  <div className='col-4'>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>CHECK IN</p>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>28/03/2024</p>
                  </div>
                  <div className='col-4'>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>CHECK OUT</p>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>30/03/2024</p>
                  </div>
                  <div className='col-4'>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>&nbsp;</p>
                    <p class="modal-title" id="exampleModalLabel" style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>2 nights</p>
                  </div>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-2' >
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>RATE</div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>Best Available Rate</div>
                  </div>
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#AEB6BF', fontWeight: 500 }}>AVG. RATE</div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}><FaIndianRupeeSign />233</div>
                  </div>
                </div>
                <hr className='mt-2 g-0' />
                <div className='d-flex justify-content-between align-items-center' >
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>2 nights</div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}>Taxes & Fees</div>
                  </div>
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}><FaIndianRupeeSign />466</div>
                    <div className='text-end' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 500 }}><FaIndianRupeeSign />74</div>
                  </div>
                </div>
                <hr className='g-0' />
                <div className='d-flex justify-content-between align-items-center' >
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 600 }}>Total</div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "12px", color: '#000', fontWeight: 500 }}>Deposit</div>
                  </div>
                  <div>
                    <div className='' style={{ fontFamily: 'Poppins', fontSize: "13px", color: '#000', fontWeight: 600 }}><FaIndianRupeeSign />540</div>
                    <div className='text-end' style={{ fontFamily: 'Poppins', fontSize: "12px", color: '#000', fontWeight: 500 }}><FaIndianRupeeSign />540</div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>
            </div>
          </div>
        </div>
      </div>
      <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width: 40, height: 40, backgroundColor: "red", color: "#fff", alignItems: "center", justifyContent: "center", display: "flex" }}><IoArrowUpCircleOutline style={{ fontSize: 40 }} /></button>
    </div>
  )
}
